<template lang='pug'>
//- SideEffect-Record
div(:class='$style[`cc-side-effect-userRecord`]')
  div(v-if='initLoad' :class='$style[`cc-side-effect-userRecord-wrap`]')
    div(:class='$style[`cc-side-effect-userRecord-empty`]')
      div(:class='$style[`cc-side-effect-userRecord-empty-tips`]')
        IconLoading(:size='30' :color='`#b1b1b1`')

  div(v-else-if='isEmpty' :class='$style[`cc-side-effect-userRecord-wrap`]')
    div(:class='$style[`cc-side-effect-userRecord-empty`]')
      div.font-medium(:class='$style[`cc-side-effect-userRecord-empty-tips`]') 無任何紀錄
      router-link.btn-extra(
        role='button'
        tabindex='0'
        aria-label='建立副作用紀錄'
        to='/sideeffect/post'
        :class='$style[`cc-error-create`]')
        span.font-medium + 建立新記錄

  div(v-else :class='$style[`cc-side-effect-userRecord-wrap`]')
    div(:class='$style[`cc-side-effect-userRecord-filter`]')
      button(
        tabindex='0'
        aria-label='查看所有記錄'
        :class='[$style[`cc-side-effect-userRecord-filter-btn`], $style[filterRange === 0 ? `cc-selected` : ``]]'
        @click='switchFilterRange(0)') 全部

      button(
        tabindex='0'
        aria-label='查看近一個月記錄'
        :class='[$style[`cc-side-effect-userRecord-filter-btn`], $style[filterRange === 30 ? `cc-selected` : ``]]'
        @click='switchFilterRange(30)') 近30天

      //- button(
      //-   tabindex='0'
      //-   aria-label='查看近一個月記錄'
      //-   :class='[$style[`cc-side-effect-userRecord-filter-btn`], $style[filterRange === 30 ? `cc-selected` : ``]]'
      //-   @click='switchFilterRange(30)') 健檢分析

      router-link.btn-confirm-extra(
        v-if='rwdType !== `desktop`'
        exact=true
        role='button'
        tabindex='0'
        aria-label='健檢與預測分析'
        :to='`/sideeffect/record?r=summary`'
        :class='$style[`cc-side-effect-userRecord-filter-btn-chart`]') 健檢 / 預測分析

      //- button(
      //-   tabindex='0'
      //-   aria-label='查看近三個月記錄'
      //-   :class='[$style[`cc-side-effect-userRecord-filter-btn`], $style[filterRange === 90 ? `cc-selected` : ``]]'
      //-   @click='switchFilterRange(90)') 近3個月

    //- div(:class='$style[`cc-side-effect-analysis`]')
    //-   ProgressBar


    div(v-if='preloading' :class='$style[`cc-side-effect-userRecord-preload`]')
      IconLoading(:size='30' :color='`#b1b1b1`')

    div(:class='$style[`cc-side-effect-userRecord-container`]')
      div(v-if='dataContainer.length' :class='$style[`cc-side-effect-userRecord-tips`]')
        span 紀錄評比
        div(:class='$style[`cc-side-effect-userRecord-tips-list`]')
          mark(:class='$style[`cc-top-tips-mark-yellow`]')
          span 中等
          div(:class='$style[`cc-side-effect-userRecord-tips-list`]')
          mark(:class='$style[`cc-top-tips-mark-red`]')
          span 嚴重
      div(:class='$style[`cc-side-effect-userRecord-ul`]')
        router-link(
          v-for='items, index in dataContainer'
          exact=true
          role='button'
          tabindex='0'
          aria-label='查看內容'
          :to='`/sideeffect/record?r=${items.rid}`'
          :active-class='$style[`js-selected`]'
          :key='index'
          :class='[$style[`cc-side-effect-userRecord-nav`], $style[items.isLast ? `top-space` : ``]]')
          mark(v-if='items.alert_level === 1' :class='[$style[`cc-top-space-alert-mark`], $style[`alert-mark-yellow`]]')
          mark(v-else-if='items.alert_level === 2' :class='[$style[`cc-top-space-alert-mark`], $style[`alert-mark-red`]]')

          div
            div(v-if='items.isLast' :class='$style[`cc-top-space-month`]')
              span.font-bold {{ handleTransferString(items.isLast) }}

            div(:class='[$style[`cc-side-effect-userRecord-item`], $style[`cc-side-effect-userRecord-item-date`]]' style='flex: 0 0 10%')
              span.font-bold(:class='$style[`cc-text-value`]') {{ captureLastCharDate(items.date) }}

            div(:class='[$style[`cc-side-effect-userRecord-item`], $style[`cc-side-effect-userRecord-item-weight`]]' style='flex: 0 0 25%')
              //- span 接受治療
              span.font-medium(v-if='items.now_treatment' :class='$style[`cc-text-value`]') {{ items.now_treatment }}
              span.font-medium(v-else :class='$style[`cc-text-value`]') -

            div(:class='[$style[`cc-side-effect-userRecord-item`], $style[`cc-side-effect-userRecord-item-weight`]]' style='flex: 0 0 10%')
              span(:class='$style[`cc-text-topic`]') 體重
              span.font-bold(:class='$style[`cc-text-value`]') {{ items.weight }}
                span(v-show='rwdType !== `mobile`').font-bold KG

            div(:class='[$style[`cc-side-effect-userRecord-item`], $style[`cc-side-effect-userRecord-item-quality`]]' style='flex: 0 0 10%')
              span(:class='$style[`cc-text-topic`]') 生活
              span.font-bold(:class='[$style[`cc-text-value`], $style[`value-color${items.qualitylife}`]]') {{ items.qualitylife }}

            div(:class='[$style[`cc-side-effect-userRecord-item`], $style[`cc-side-effect-userRecord-item-pain`]]' style='flex: 0 0 10%')
              span(:class='$style[`cc-text-topic`]') 疼痛
              span.font-bold(:class='[$style[`cc-text-value`], $style[`value-color${items.painlevel}`]]') {{ items.painlevel }}

            div(:class='[$style[`cc-side-effect-userRecord-item`], $style[`cc-side-effect-userRecord-item-emotion`]]' style='flex: 0 0 10%')
              span(:class='$style[`cc-text-topic`]') 心情
              span.font-bold(:class='[$style[`cc-text-value`], $style[`value-color${items.emotion}`]]') {{ items.emotion }}

            //- div(:class='[$style[`cc-side-effect-userRecord-item`], $style[`cc-side-effect-userRecord-item-event`]]')
            //-   span 重大事件
            //-   span.font-bold(:class='$style[`cc-text-value`]') {{ items.event === '0' ? '-' : '有' }}

            //- div(:class='[$style[`cc-side-effect-userRecord-item`], $style[`cc-side-effect-userRecord-item-event`]]')
            //-   span 臨床計畫
            //-   span.font-bold(:class='$style[`cc-text-value`]') {{ items.plan === '0' ? '-' : '有' }}

            div(:class='[$style[`cc-side-effect-userRecord-item`], $style[`cc-side-effect-userRecord-item-download`]]')
              IconSearch(:size='18' :color='`#98a1a1`')
              //- span 查看

      //- LazyLoad
      infinite-loading(:identifier='infiniteId' @infinite='infiniteHandler')
        div(slot='spinner')
          IconLoading(
            slot='spinner'
            :size='30'
            :color='`#b1b1b1`')

        div.infinite-scroll-slot(slot='no-more' style='padding-top: 15px;')
          span.infinite-scroll-slot-noMore 沒有更多資料

        div.infinite-scroll-slot(slot='no-results' style='padding-top: 15px;')
          span.infinite-scroll-slot-noMore 沒有更多資料

</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import IconLoading from '../../icon/Loading';
import IconSearch from '../../icon/Search';
import GlobalEmitter from 'tiny-emitter/instance';
// import ProgressBar from '../common/ProgressBar.vue';
// import IconDownload from '../../icon/Download';

import {
  getLoadSideEffectList,
} from '../../../js/restapi';

export default {
  metaInfo() {
    return {
      title: '智慧紀錄',
      titleTemplate: '%s | Cancell 醫抗癌',
      meta: [{
        name: 'og:url',
        content: 'https://cancell.tw/sideeffect/record',
      }],
      link: [{
        rel: 'canonical',
        href: 'https://cancell.tw/sideeffect/record',
      }],
    };
  },

  components: {
    IconLoading,
    IconSearch,
    // ProgressBar,
    // IconDownload,
  },
  
  data() {
    return {
      initLoad: true,
      preloading: true,
      isEmpty: false,

      filterRange: 0,
      pageSize: 10,
      pageIndex: 1,
      dataContainer: [],

      infiniteId: +new Date(),
    };
  },

  created() {
    this.axiosLoadUserSideEffectList();
    this.detectGlobalEmitter();
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
    }),

    infiniteHandler($state) {
      if (!this.preLoading) {
        // const jwtAccess = JSON.parse(this.authJwtToken).a;
  
        getLoadSideEffectList('', {
          aid: `${this.loginDjangoId}`,
          days: this.filterRange,
          page: `${this.pageIndex}`,
          size: `${this.pageSize}`,
        }, {
            headers: {
              'content-Type': 'application/json',
              // Authorization: `Bearer ${jwtAccess}`,
            },
          })
          .then((res) => {
            res.data.results.map((x) => this.dataContainer.push(x));
            console.log('LazyLoad Success', this.dataContainer);

            if (res.data.results.length < this.pageSize || this.dataContainer.length === res.data.count) {
              $state.complete();
            } else {
              this.pageIndex += 1;
            }
            $state.loaded();
          })
          .catch((err) => {
            console.log('讀取副作用清單 Error', err);
          })
      } else {
        $state.complete();
      }
    },

    detectGlobalEmitter() {
      let vm = this;
      GlobalEmitter.on('reload-record', function (arg) {
        vm.preloading = true;
        vm.isEmpty = false;
        vm.pageIndex = 1;
        vm.dataContainer = [];
        vm.axiosLoadUserSideEffectList();
      });
    },

    handleTransferString(str) {
      let newStr = str.replace('.', '年') + '月';
      return newStr;
    },

    switchFilterRange(rangeNum) {
      this.preloading = true;
      this.isEmpty = false;
      this.pageIndex = 1;
      this.filterRange = rangeNum;
      this.dataContainer = [];

      if (this.$router.currentRoute.name !== 'effect-record') {
        this.$router.push({
          name: 'effect-record',
        }).catch(() => true);
      }
      this.axiosLoadUserSideEffectList();
    },

    captureLastCharDate(str) {
      const newstr = str.substr(str.length - 5, str.length).replace('.', '/');
      return newstr;
    },

    axiosLoadUserSideEffectList() {
      // const jwtAccess = JSON.parse(this.authJwtToken).a;
      getLoadSideEffectList('', {
        aid: `${this.loginDjangoId}`,
        days: this.filterRange,
        page: `${this.pageIndex}`,
        size: `${this.pageSize}`,
      }, {
          headers: {
            'content-Type': 'application/json',
            // Authorization: `Bearer ${jwtAccess}`,
          },
        })
        .then((res) => {
          if (!res.data.count) {
            this.isEmpty = true;
          } else {
            this.dataContainer = res.data.results;
            this.pageIndex += 1;
          }

          console.log('讀取副作用清單 Success', this.dataContainer);
          this.preloading = false;
          this.initLoad = false;
        })
        .catch((err) => {
          console.log('讀取副作用清單 Error', err);
          this.changePopBoxStatus({
            active: true,
            include: 'warnError',
          });
        })
    }
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      rwdType: 'global/exportRwdType',
      loginDjangoId: 'user/exportUserDjangoId',
      loginStatus: 'user/exportLoginStatus',
      // loginProfile: 'user/exportUserProfile',
      authJwtToken: 'user/exportUserJwtToken',
    }),
  },
};
</script>

<style module lang='scss'>
  @import '../../../sass/component/page/sideeffect/effectRecord.scss';
</style>
